import React from "react"
import classNames from "classnames"

import styles from "./index.less"

export function ErrorPageComponent({ title, message }) {
  return (
    <div className="sfl-wrapper">
      <div className="container">
        <div id="sfl-container">
          <div className="panel panel-default">
            <div className="panel-heading">
              <a className="nav-logo">
                <div className="logo-header-background-dark" />
              </a>
            </div>
            <div className="panel-body">
              <div id="sfl-body" className="show">
                <div>
                  <h2 className={styles.title}>{title}</h2>
                  {message && <div>{message}</div>}
                  <div>
                    Please, check URL address or contact us{" "}
                    <a href="mailto:servicedesk@cirrusassessment.com">
                      servicedesk@cirrusassessment.com
                    </a>
                  </div>
                  <div className={classNames("form-buttons", styles.footer)}>
                    <a href={location.origin}>Login</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
